module.exports = __webpack_public_path__ + "static/img/risk_01_2025.6004aa0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/risk/risk_01_2025.jpg
// module id = LCRD
// module chunks = 99